/**
 * Version des CGV en vigueur, source unique de vérité.
 * Utilisée pour lier chaque consentement électronique à la version exacte
 * acceptée par le signataire (traçabilité art. 14 CO).
 */
export const CGV_VERSION = "2026-10";
